<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >业务资源管理（客户管理）</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/resourceIndex/allocationIndex' }"
          >客户资源分配管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/resourceIndex/rAllocationDetail' }"
          >客户详情</el-breadcrumb-item
        >
        <el-breadcrumb-item>分配客户资源</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <h1>分配客户资源给销售专员</h1>
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>分配给</p>
            <div class="select_customer flex-rowc" @click="handleShowUser">
              选择员工
            </div>
            <!-- 选中的员工 -->
            <div class="select_customer_wrap" v-if="selectQy.id">
              <p>
                员工姓名：<span>{{ selectQy.user.truename }}</span>
              </p>
              <p>
                部门：<span>{{ selectQy.deptname }}</span>
              </p>
              <p>
                角色：<span>{{ selectQy.rolename }}</span>
              </p>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>分配类型</p>
            <div class="select_box">
              <el-select
                v-model="formData.gettype"
                placeholder="请选择分配类型"
                @visible-change="getQywxset('customershare')"
              >
                <el-option
                  v-for="item in customershareOption"
                  :key="item.id"
                  :label="item.evalue"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>备注：</p>
            <div class="input_box">
              <el-input
                v-model="formData.details"
                placeholder="请输入备注"
                type="textarea"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="tip_wrap">
          <div class="item">
            <h1>客户名称：</h1>
            <p>
              {{
                customerDetail.info_truename
                  ? customerDetail.info_truename
                  : customerDetail.ext_name
              }}
            </p>
          </div>
          <div class="item">
            <h1>企业名称：</h1>
            <p>{{ customerDetail.other_companystr }}</p>
          </div>
          <div class="item">
            <h1>职务：</h1>
            <p>{{ customerDetail.other_job }}</p>
          </div>
          <div class="item">
            <h1>联系方式：</h1>
            <p>{{ customerDetail.info_mobile }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->

    <!-- 品牌添加 -->
    <div class="custom_dialog" v-show="isShow">
      <div class="custom_wrap">
        <div class="diaog_head">
          <div class="close_icon" @click="isShow = false">
            <i class="iconfont icon-guanbi"></i>
          </div>
          <div class="search_box flex-between">
            <el-input
              v-model="customerParams.keyword"
              placeholder="输入员工姓名/ID/部门，查找后选择员工"
              @keyup.enter.native="getApplyCompanyList"
            ></el-input>
            <div class="search_btn flex-rowc" @click="getApplyCompanyList">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
        </div>
        <div class="diaog_body">
          <div class="radio_wrap">
            <div class="radio_group flex-rowl" v-if="qyList.length > 0">
              <div
                class="radio_item flex-rowl"
                v-for="item in qyList"
                :key="item.id"
                @click="handleUser(item.id)"
              >
                <i
                  class="iconfont"
                  :class="
                    selectQyId === item.id
                      ? 'icon-danxuanyixuan1'
                      : 'icon-quanxuan'
                  "
                ></i>
                <div class="radio_content">
                  <p>
                    员工姓名：<span>{{ item.user.truename }}</span>
                  </p>
                  <p>
                    部门：<span>{{ item.deptname }}</span>
                  </p>
                  <p>
                    角色：<span>{{ item.rolename }}</span>
                  </p>
                </div>
              </div>
            </div>
            <el-empty description="暂无成员" v-else></el-empty>
          </div>
        </div>
        <div class="dialog_footer flex-rowl">
          <div class="btn" @click="handleQueryQy">确认</div>
          <div class="return_txt" @click="isShow = false">←返回</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getQywxset,
  getCustomerDetail,
  addCustomerDis,
  editCustomerDis,
  getCustomerDisDetail,
  encryptstringview,
} from "../../../api/api";
import { getApplyCompanyList } from "../../../api/company";
import { mapState } from "vuex";
export default {
  name: "rAllocationCustomer",
  data() {
    return {
      qyid: "",
      id: "",
      idc: "",
      loading: false,
      formData: {
        openid: this.$store.state.OPENID,
        cmuseropenid: "", // 分配人员 openid
        customerid: "",
        // createdate: "",
        getstate: "",
        gettype: "",
        result: 1,
        details: "",
        others: "",
      },
      gettypestr: "", // 分配类型
      customerDetail: "", // 客户详情

      // 企业成员
      qyList: [],
      selectQyId: "",
      selectQy: {}, // 选择的企业

      customershareOption: [],
      isShow: false,
      searchText: "",

      customerParams: {
        qyid: "",
        keyword: "",
        checkstate: 1, // 0审核中 1已通过 2拒绝加入 3已退出 4已被移出
      },
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.customerParams.qyid = USERINFO.qy.id ? USERINFO.qy.id : "";

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, idC } = JSON.parse(res.jsondata);
        this.id = id;
        this.idc = idC;
        this.formData.customerid = id;

        this.getCustomerDetail();
        if (idC != 0) {
          this.getCustomerDisDetail();
        }
      } else {
        this.$router.back();
      }
    },

    // 获取触达详情
    getCustomerDisDetail() {
      getCustomerDisDetail({ id: this.idc }).then((res) => {
        this.formData.customerid = res.customerid;
        this.formData.id = res.id;
        this.formData.getstate = res.getstate;
        this.getstatestr = res.getstatestr;
        // this.formData.gettype = res.gettype;
        this.gettypestr = res.gettypestr;
        this.formData.result = res.result;
        this.resultstr = res.resultstr;
        this.formData.details = res.details;
        this.formData.others = res.others;
        this.formData.cmuseropenid = res.cmuseropenid;
        // this.getQywxset("customershare");
        this.getApplyCompanyList(res.cmuseropenid);
      });
    },
    // 获取客户详情
    getCustomerDetail() {
      getCustomerDetail({ id: this.id }).then((res) => {
        this.customerDetail = res;
      });
    },

    handleShowUser() {
      this.getApplyCompanyList();
      this.isShow = true;
    },
    // 获取企业成员
    getApplyCompanyList(cmuseropenid) {
      getApplyCompanyList(this.customerParams).then((res) => {
        this.qyList = res;
        // this.qyList = res.filter((v) => v.rolename != "创建人");
        if (cmuseropenid != "" && cmuseropenid) {
          res.forEach((v) => {
            if (v.openid == cmuseropenid) {
              this.selectQy = v;
            }
          });
        }
      });
    },

    getQywxset(value) {
      let { idc, customerDetail } = this;
      console.log(customerDetail,customerDetail.gettype, "===");
      getQywxset(value).then((res) => {
        if (idc != "") {
          if (customerDetail.gettype) {
            this.customershareOption = res.filter(
              (v) => v.evalue != "首次分配"
            );
          } else {
            this.customershareOption = res;
          }
        } else {
          if (customerDetail.gettype) {
            this.customershareOption = res.filter(
              (v) => v.evalue != "首次分配"
            );
          } else {
            this.customershareOption = res;
          }
        }
      });
    },
    // 员工选择
    handleUser(id) {
      this.selectQyId = id;
    },
    // 选中员工
    handleQueryQy() {
      let { selectQyId, qyList } = this;
      if (selectQyId == "") {
        this.$message.warning("请选择员工");
      } else {
        qyList.forEach((v) => {
          if (v.id == selectQyId) {
            this.selectQy = v;
            this.formData.cmuseropenid = v.openid;
          }
        });
        this.isShow = false;
      }
    },

    query() {
      let { formData, idc } = this;
      if (formData.cmuseropenid == "") {
        this.$message.warning("请选择分配人员 ");
        return;
      }
      if (formData.gettype == "") {
        this.$message.warning("请选择分配类型");
        return;
      }
      if (idc == 0) {
        this.addCustomerDis();
      } else {
        this.editCustomerDis();
      }
    },

    // 修改
    editCustomerDis() {
      this.loading = true;
      console.log(this.formData, "======this.formData");
      editCustomerDis(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    // 新增
    addCustomerDis() {
      this.loading = true;
      addCustomerDis(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
        .select_customer {
          border: 1px solid #dcdfe6;
          background: #fff;
          height: 40px;
          cursor: pointer;
        }
        .select_customer_wrap {
          border: 1px solid #dcdfe6;
          background: #fff;
          margin-top: 20px;
          padding: 10px 20px;
          box-sizing: border-box;
          p {
            font-size: 14px;
          }
        }
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
          }
        }
      }
    }
  }
  .custom_wrap {
    .diaog_body {
      h1 {
        font-size: 18px;
        color: #6e6e6e;
      }
      p {
        font-size: 14px;
        // color: #ff0012;
        margin: 15px 0 14px;
      }
      .radio_wrap {
        .radio_group {
          flex-wrap: wrap;
          .radio_item {
            flex-shrink: 0;
            width: 100%;
            border: 1px solid #dcdcdc;
            margin-right: 80px;
            font-size: 14px;
            color: #6e6e6e;
            margin-bottom: 20px;
            padding: 0 10px;
            box-sizing: border-box;
            cursor: pointer;
            .iconfont {
              font-size: 22px;
              margin-right: 10px;
              color: #a5a5a5;
              &.icon-danxuanyixuan1 {
                color: #f62560;
              }
            }
          }
        }
      }
    }
    .dialog_footer {
      .link {
        a {
          font-size: 16px;
          color: #f62560;
        }
      }
    }
  }
}
</style>